import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {SERVER_API_URL} from '../../app.constants';
import {createRequestOption} from '../../shared/util/request-util';
import {IOrderItems} from "../../shared/model/orderItems.model";


type EntityResponseType = HttpResponse<IOrderItems>;
type EntityArrayResponseType = HttpResponse<IOrderItems[]>;

@Injectable({providedIn: 'root'})
export class OrderItemsService {
  public resourceUrl = SERVER_API_URL + 'api/orderItemss';

  constructor(protected http: HttpClient) {
  }

  create(orderItems: IOrderItems): Observable<EntityResponseType> {
    return this.http.post<IOrderItems>(this.resourceUrl, orderItems, {observe: 'response'});
  }

  update(orderItems: IOrderItems): Observable<EntityResponseType> {
    return this.http.put<IOrderItems>(this.resourceUrl, orderItems, {observe: 'response'});
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http.get<IOrderItems>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }

  findOrderCount(): Observable<HttpResponse<any>> {
    return this.http
      .get<any>(`${this.resourceUrl + '-all-count'}`, {observe: 'response'});
  }

  findOrderMonthly(param:any): Observable<HttpResponse<any>> {
    return this.http
      .get<IOrderItems>(`${this.resourceUrl + '-monthly/'+param}`, {observe: 'response'});
  }

  findOrderSumSales(param:any): Observable<HttpResponse<any>> {
    return this.http
      .get<any>(`${this.resourceUrl + '-sum-sales/'+param}`, {observe: 'response'});
  }
  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IOrderItems[]>(this.resourceUrl, {params: options, observe: 'response'});
  }
  search(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IOrderItems[]>(this.resourceUrl+'-search', {params: options, observe: 'response'});
  }

  findWithCustomerId(req?: any, id?:any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IOrderItems[]>(this.resourceUrl + '-customer/'+id, {params: options, observe: 'response'});
  }

  getListOrderItemsByByFilter(id?: any): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http.get<IOrderItems[]>(this.resourceUrl + '-filter-calendar/'+id, {params: null, observe: 'response'});
  }

  // findByStatus(req?: any, status?:any): Observable<EntityArrayResponseType> {
  //   const options = createRequestOption(req);
  //   return this.http.get<IOrderItems[]>(this.resourceUrl + '-list-status/'+status, {params: options, observe: 'response'});
  // }

  findByStatus(req?: any, status?:any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IOrderItems[]>(this.resourceUrl+'-list-status/'+status, {params: options, observe: 'response'});
  }


  chekFOrArchive(id?:any): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http.get<IOrderItems[]>(this.resourceUrl+'-check-archive/'+id, {params: null, observe: 'response'});
  }

  delete(id: number): Observable<HttpResponse<any>> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }


  querySendNotify(req?: any): Observable<HttpResponse<IOrderItems[]>> {
    const options = createRequestOption(req);

    return this.http.get<any>(this.resourceUrl+'-send-notify', { params: options, observe: 'response' });
  }
}
